import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { FAILED_STATUSES, IncomingBankPaymentStatusEnum } from 'src/shared/models/enums/incomingBankPaymentStatus.enum';

type IncomingBankPaymentStatusesProps = {
  status: number;
  chipSize: 'small' | 'medium' | undefined;
};

export const IncomingBankPaymentStatuses = (props: IncomingBankPaymentStatusesProps) => {
  const { status, chipSize } = props;
  const { t } = useTranslation(['invoice']);
  const isFailed = FAILED_STATUSES.includes(status as IncomingBankPaymentStatusEnum);
  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {status === IncomingBankPaymentStatusEnum.Matched && (
        <Tooltip describeChild title={`${t('invoice:incomingBankPaymentStatus.Matched')}`} arrow>
          <CustomChip label={t('invoice:incomingBankPaymentStatus.Matched')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {status === IncomingBankPaymentStatusEnum.UnMatched && (
        <Tooltip describeChild title={`${t('invoice:incomingBankPaymentStatus.UnMatched')}`} arrow>
          <CustomChip label={t('invoice:incomingBankPaymentStatus.UnMatched')} color='error' size={chipSize} />
        </Tooltip>
      )}
      {isFailed && (
        <Tooltip describeChild title={t(`invoice:incomingBankPaymentStatus.${IncomingBankPaymentStatusEnum[status]}Tooltip`)} arrow>
          <CustomChip label={t(`invoice:incomingBankPaymentStatus.${IncomingBankPaymentStatusEnum[status]}`)} color='warning' size={chipSize} />
        </Tooltip>
      )}
      {!isFailed && status !== IncomingBankPaymentStatusEnum.Matched && status !== IncomingBankPaymentStatusEnum.UnMatched && (
        <Tooltip describeChild title={`${t('invoice:incomingBankPaymentStatus.UnHandled')}`} arrow>
          <CustomChip label={t('invoice:incomingBankPaymentStatus.UnHandled')} color='grey' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
